<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Nome"
            class="col-md-12"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Descrição (opcional)"
            class="col-12"
          >
            <b-textarea v-model="form.descricao" />
          </b-form-group>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comercial/tipo-atividade/shared/services/api'

export default {
  name: 'TipoAtividade',
  components: {
    ValidationProvider,
    CadastroBase,
  },
  data() {
    return {
      required,
      form: {
        nome: '',
        descricao: '',
      },
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getTipoAtividade(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createTipoAtividade(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Tipo de atividade cadastrada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateTipoAtividade(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Tipo de atividade alterada com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
  },
}
</script>
